import repository from "@/plugins/axios/secureClient";

const userResource = "/users";

export default {
  getList(params) {
    return repository.get(`${userResource}/`, { params });
  },
  getOne(id) {
    return repository.get(`${userResource}/${id}`);
  },
  create(payload) {
    return repository.post(`${userResource}/`, payload);
  },
  update(id, payload) {
    return repository.put(`${userResource}/${id}`, payload);
  },
  delete(id) {
    return repository.delete(`${userResource}/${id}`);
  },
  getHistory(id) {
    return repository.get(`${userResource}/${id}/history`);
  }
};
